import * as React from 'react';
import { BadgeComponent, CloseIcon, BadgeContent } from './styles';

export type Props = {
  color?: 'danger' | 'success' | 'warning' | 'primary' | 'secondary' | 'tertiary';
  isCapitalized?: boolean;
  onlyText?: boolean;
  size?: 'xsmall' | 'small' | 'large';
  onDelete?: () => void;
  children?: string | number | JSX.Element | JSX.Element[] | React.ReactNode;
  className?: string;
};

const Badge = ({ onDelete, children, ...props }: Props) => {
  return (
    <BadgeComponent {...props}>
      <BadgeContent isCapitalized={props.isCapitalized}>{children}</BadgeContent>
      {onDelete && <CloseIcon onClick={onDelete} color={props.color} size={props.size} />}
    </BadgeComponent>
  );
};

export default Badge;
